<template>
  <div class="who-we-are">
    <HeaderStyles1>
      <h1 slot="title" v-html="$t('who-are-we-head-h1')"></h1>
      <p slot="detail" v-html="$t('who-are-we-head-small')"></p>
      <b-img class="platform-title-img" slot="image" src="../assets/imgs/head-img-who-we-are.png" alt="" />
    </HeaderStyles1>

    <b-container class="content">
      <b-row>
        <b-col class="item" cols="12" sm="12" md="6" xl="6">
          <b-img fluid src="../assets/imgs/who-are-we-img-1.png"></b-img>
          <h2>Indoor Positioning</h2>
        </b-col>
        <b-col class="item" cols="12" sm="12" md="6" xl="6">
          <b-img fluid src="../assets/imgs/who-are-we-img-2.png"></b-img>
          <h2>Location Based Service</h2>
        </b-col>
        <b-col class="item" cols="12" sm="12" md="6" xl="6">
          <b-img fluid src="../assets/imgs/who-are-we-img-3.png"></b-img>
          <h2>AI Advertisement</h2>
        </b-col>
        <b-col class="item" cols="12" sm="12" md="6" xl="6">
          <b-img fluid src="../assets/imgs/who-are-we-img-4.png"></b-img>
          <h2>Trend Predictive Analytic</h2>
        </b-col>
        <b-col class="item" cols="12" sm="12" md="6" xl="6">
          <b-img fluid src="../assets/imgs/who-are-we-img-5.png"></b-img>
          <h2>User Profiling</h2>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import HeaderStyles1 from '../components/HeaderStyles1.vue'
export default {
  name: 'SmartVenues',
  components: {
    HeaderStyles1
  },
  data () {
    return {

    }
  }
}
</script>

<style scoped lang="scss">
  .who-we-are {
    .platform-title-img {
      width: 50%;
      bottom: 30px;
    }

    .content {
      margin-top: 110px;
    }

    .item {
      text-align: center;
      margin-bottom: 170px;

      img {
        height: 366px;
        object-fit: contain;
        object-position: bottom;
      }
      h2 {
        text-align: center;
        margin-top: 60px;
        font-size: 34px;
        font-weight: bold;
      }
    }
  }
</style>
